const config = {
  appId: 'fyqsvGDYCobcqUNxygYnZ90de54LiMg8ghyORzu3',
  serverUrl: 'https://38yhxirhywoy.grandmoralis.com:2053/server',
}

export default config
